<template>
	<v-btn
		v-bind="attrs"
		class="base-btn base-shadow"
		@click="$emit('click', $event)"
	>
		<slot />
	</v-btn>
</template>

<script>
export default {
	name: 'BaseBtn',
	props: {
		primary: {
			type: Boolean,
			default: true,
		},
		icon: {
			type: Boolean,
			default: false,
		},
		secondary: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		attrs() {
			const attrs = {
				class: [{ icon: this.icon }],
			}

			if (this.secondary) {
				attrs.class.push('base-btn__secondary')
			} else if (this.primary) {
				attrs.class.push('base-btn__primary')
			}

			return attrs
		},
	},
}
</script>

<style lang="scss">
.base-btn {
	height: 40px !important;
	font-family: 'Acumin Pro';
	font-size: 17px !important;
	line-height: 17px !important;
	font-weight: normal !important;
	letter-spacing: normal !important;
	border-radius: 5px !important;
	text-transform: none !important;

	&:not(.icon) {
		padding: 0 20px !important;
		min-width: 120px !important;
	}
	&.icon {
		padding: 0 8px !important;
		min-width: 40px !important;
	}

	.v-btn__content {
		& > *:not(:first-child) {
			margin-left: 4px;
		}
		span {
			margin-top: 4px;
		}
	}

	&__primary {
		color: white !important;
		background-color: #0685af !important;
	}

	&__secondary {
		color: white !important;
		background-color: #a5a5a5 !important;
	}
}
</style>
